module.exports = __webpack_public_path__ + "static/bg10.f46a5da0.png";